import React, { useState, useEffect } from "react";
import { Label } from '@/components/ui/label';
import { Input } from '@/components/ui/input';
import { cn } from '@/lib/utils';

export function DateTimeSelector({ value, onChange }) {
  const [minDateTime, setMinDateTime] = useState("");

  useEffect(() => {
    const now = new Date();
    const localISOTime = new Date(now.getTime() - now.getTimezoneOffset() * 60000)
      .toISOString()
      .slice(0, 16);
    setMinDateTime(localISOTime);
    
    // Set initial value if not provided
    if (!value) {
      onChange(localISOTime);
    }
  }, []);

  return (
    <div className={cn("space-y-2")}>
      <Label htmlFor="datetime-input">Schedule Date/Time:</Label>
      <Input
        type="datetime-local"
        id="datetime-input"
        value={value || minDateTime}
        onChange={(e) => onChange(e.target.value)}
        min={minDateTime}
        className="w-full"
      />
    </div>
  );
}